import { useEffect, useMemo } from 'react';
import { StringParam, DateParam, useQueryParams } from 'use-query-params';

import { PreDefinedPeriod } from '../types';
import { isValidRangeQuery, getDisplayRangeFromPreDefinedPeriod } from '../utils';

const DEFAULT_PERIOD: PreDefinedPeriod = 'yesterday';

export default function useDatePeriod() {
  const [dateRangeQuery, setDateRangeQuery] = useQueryParams({
    period: StringParam,
    from: DateParam,
    to: DateParam,
  });

  useEffect(() => {
    if (!isValidRangeQuery(dateRangeQuery)) {
      setDateRangeQuery({ period: DEFAULT_PERIOD, from: null, to: null }, 'replace');
    }
  }, [dateRangeQuery, setDateRangeQuery]);

  const downloadPeriod = !isValidRangeQuery(dateRangeQuery) ? DEFAULT_PERIOD : dateRangeQuery.period;

  const parseDateRangeQuery = useMemo(() => {
    if (!isValidRangeQuery(dateRangeQuery)) {
      return getDisplayRangeFromPreDefinedPeriod(DEFAULT_PERIOD);
    }
    if (dateRangeQuery.period === 'custom') {
      return { from: dateRangeQuery.from, to: dateRangeQuery.to };
    }
    return getDisplayRangeFromPreDefinedPeriod(dateRangeQuery.period);
  }, [dateRangeQuery]);

  return { downloadPeriod, dateRange: parseDateRangeQuery, setDateRangeQuery };
}
